<template>
  <nav class="sidebar">
    <div class="sidebar-nav">
      <ul class="nav">
        <template v-if="showMenu">
          <SidebarNavItem
            v-for="item in navItems"
            v-bind="item"
            :key="item.label"
          />
        </template>
      </ul>
    </div>
    <ClientLogo />
    <SidebarMinimizer />
  </nav>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'

import { useAccountsStore } from '@/stores/accounts'

import SidebarMinimizer from './SidebarMinimizer.vue'
import SidebarNavItem from './SidebarNavItem.vue'
import ClientLogo from '@/components/ClientLogo.vue'

import { getMenu } from '@/menu'

defineOptions({ name: 'Sidebar' })

const route = useRoute()

const accountsStore = useAccountsStore()
const { user } = storeToRefs(accountsStore)

const navItems = ref(null)

const showMenu = computed(() => {
  const { showMenu = true } = route.meta
  return showMenu
})

watch(user, (newUser) => {
  navItems.value = getMenu(newUser)
}, { immediate: true, deep: true })
</script>

<style>
  .nav-link {
    cursor:pointer;
  }
</style>
